// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to work with preval
// this file was prevaled
// we're using preval because we import tokens into Fuegokit React as a module
// Cache bust: April 23 2024 4:40:00 GMT-0600 (This file is cached by the system's deployment tooling, so you'll need update this timestamp to rebuild this file)
var themePreval = {
  "theme": {
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["350px", "544px", "768px", "1012px", "1280px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#ffffff",
                "hovered": "#f1f2f4",
                "pressed": "#dcdfe4"
              },
              "sunken": "#f7f8f9",
              "raised": {
                "default": "#ffffff",
                "hovered": "#f7f8f9",
                "pressed": "#f1f2f4"
              },
              "overlay": {
                "default": "#ffffff",
                "hovered": "#f1f2f4",
                "pressed": "#dcdfe4"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#091e4229",
                "perimeter": "#091e421f"
              }
            }
          },
          "border": {
            "default": "#091e4224",
            "selected": "#1d7afc",
            "focused": "#388bff",
            "subtle": "#091e420f",
            "input": "#091e4224",
            "inverse": "#ffffff",
            "disabled": "#091e420f",
            "brand": "#0c66e4",
            "danger": "#e2483d",
            "warning": "#e56910",
            "success": "#22a06b",
            "discovery": "#8270db",
            "information": "#1d7afc",
            "accent": {
              "blue": "#1d7afc",
              "red": "#e2483d",
              "orange": "#e56910",
              "yellow": "#b38600",
              "green": "#22a06b",
              "magenta": "#cd519d",
              "purple": "#8270db",
              "teal": "#2898bd",
              "gray": "#8590a2"
            },
            "table": {
              "default": "#091e4224"
            }
          },
          "background": {
            "accent": {
              "blue": {
                "subtlest": "#e9f2ff",
                "subtler": "#cce0ff",
                "subtle": "#579dff",
                "bolder": "#0c66e4"
              },
              "red": {
                "subtlest": "#ffeceb",
                "subtler": "#ffd5d2",
                "subtle": "#f87168",
                "bolder": "#c9372c"
              },
              "orange": {
                "subtlest": "#fff3eb",
                "subtler": "#fedec8",
                "subtle": "#fea362",
                "bolder": "#c25100"
              },
              "yellow": {
                "subtlest": "#fff7d6",
                "subtler": "#f8e6a0",
                "subtle": "#f5cd47",
                "bolder": "#946f00"
              },
              "green": {
                "subtlest": "#dcfff1",
                "subtler": "#baf3db",
                "subtle": "#4bce97",
                "bolder": "#1f845a"
              },
              "purple": {
                "subtlest": "#f3f0ff",
                "subtler": "#dfd8fd",
                "subtle": "#9f8fef",
                "bolder": "#6e5dc6"
              },
              "teal": {
                "subtlest": "#e7f9ff",
                "subtler": "#c6edfb",
                "subtle": "#6cc3e0",
                "bolder": "#227d9b"
              },
              "magenta": {
                "subtlest": "#ffecf8",
                "subtler": "#fdd0ec",
                "subtle": "#e774bb",
                "bolder": "#ae4787"
              },
              "lime": {
                "subtlest": "#efffd6",
                "subtler": "#d3f1a7",
                "subtle": "#94c748",
                "bolder": "#5b7f24"
              },
              "gray": {
                "subtlest": "#f1f2f4",
                "subtler": "#dcdfe4",
                "subtle": "#8590a2",
                "bolder": "#626f86"
              }
            },
            "input": {
              "default": "#ffffff",
              "hovered": "#f7f8f9",
              "pressed": "#ffffff"
            },
            "inverse": {
              "subtle": {
                "default": "#00000029",
                "hovered": "#0000003d",
                "pressed": "#00000052"
              }
            },
            "neutral": {
              "default": {
                "[default]": "#091e420f",
                "hovered": "#091e4224",
                "pressed": "#091e4224"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#091e420f",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546f",
                "hovered": "#2c3e5d",
                "pressed": "#172b4d"
              }
            },
            "brand": {
              "subtlest": {
                "default": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              },
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              },
              "boldest": {
                "default": "#1c2b41",
                "hovered": "#09326c",
                "pressed": "#0055cc"
              }
            },
            "selected": {
              "default": {
                "[default]": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              },
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              }
            },
            "disabled": "#f7f8f9",
            "information": {
              "default": {
                "[default]": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              },
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              }
            },
            "danger": {
              "default": {
                "[default]": "#ffeceb",
                "hovered": "#ffd5d2",
                "pressed": "#fd9891"
              },
              "bold": {
                "default": "#c9372c",
                "hovered": "#ae2e24",
                "pressed": "#5d1f1a"
              }
            },
            "success": {
              "default": {
                "[default]": "#dcfff1",
                "hovered": "#baf3db",
                "pressed": "#7ee2b8"
              },
              "bold": {
                "default": "#1f845a",
                "hovered": "#216e4e",
                "pressed": "#164b35"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#f3f0ff",
                "hovered": "#dfd8fd",
                "pressed": "#b8acf6"
              },
              "bold": {
                "default": "#6e5dc6",
                "hovered": "#5e4db2",
                "pressed": "#352c63"
              }
            },
            "warning": {
              "default": {
                "[default]": "#fff7d6",
                "hovered": "#f8e6a0",
                "pressed": "#f8e6a0"
              },
              "bold": {
                "default": "#f5cd47",
                "hovered": "#e2b203",
                "pressed": "#cf9f02"
              }
            }
          },
          "blanket": {
            "default": "#091e427d",
            "selected": "#388bff14",
            "danger": "#ef5c4814"
          },
          "text": {
            "default": "#172b4d",
            "subtle": "#44546f",
            "subtlest": "#626f86",
            "disabled": "#8590a2",
            "selected": "#0c66e4",
            "inverse": "#ffffff",
            "success": "#216e4e",
            "danger": "#ae2e24",
            "information": "#0055cc",
            "warning": {
              "default": "#a54800",
              "inverse": "#172b4d"
            },
            "discovery": "#5e4db2",
            "brand": "#0c66e4",
            "accent": {
              "blue": {
                "default": "#0055cc",
                "bolder": "#09326c"
              },
              "red": {
                "default": "#ae2e24",
                "bolder": "#5d1f1a"
              },
              "orange": {
                "default": "#a54800",
                "bolder": "#702e00"
              },
              "yellow": {
                "default": "#7f5f01",
                "bolder": "#533f04"
              },
              "green": {
                "default": "#216e4e",
                "bolder": "#164b35"
              },
              "purple": {
                "default": "#5e4db2",
                "bolder": "#352c63"
              },
              "teal": {
                "default": "#206a83",
                "bolder": "#164555"
              },
              "magenta": {
                "default": "#943d73",
                "bolder": "#50253f"
              },
              "gray": {
                "default": "#44546f",
                "bolder": "#091e42"
              },
              "lime": {
                "default": "#4c6b1f",
                "bolder": "#37471f"
              }
            }
          },
          "link": {
            "default": "#0c66e4",
            "hovered": "#0c66e4",
            "pressed": "#0055cc",
            "visited": "#5e4db2"
          },
          "icon": {
            "accent": {
              "blue": "#1d7afc",
              "red": "#c9372c",
              "orange": "#e56910",
              "yellow": "#b38600",
              "green": "#22a06b",
              "purple": "#8270db",
              "teal": "#2898bd",
              "magenta": "#cd519d",
              "gray": "#758195",
              "lime": "#6a9a23"
            },
            "default": "#44546f",
            "subtle": "#626f86",
            "inverse": "#ffffff",
            "disabled": "#8590a2",
            "brand": "#0c66e4",
            "selected": "#0c66e4",
            "danger": "#c9372c",
            "success": "#22a06b",
            "discovery": "#8270db",
            "information": "#1d7afc",
            "warning": {
              "default": "#e56910",
              "inverse": "#172b4d"
            }
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052"
          },
          "skeleton": {
            "default": "#091e420f",
            "subtle": "#091e4208"
          },
          "chart": {
            "brand": {
              "default": "#1d7afc",
              "hovered": "#0c66e4"
            },
            "neutral": {
              "default": "#8590a2",
              "hovered": "#758195"
            },
            "success": {
              "default": {
                "[default]": "#22a06b",
                "hovered": "#1f845a"
              },
              "bold": {
                "default": "#216e4e",
                "hovered": "#164b35"
              }
            },
            "danger": {
              "default": {
                "[default]": "#f15b50",
                "hovered": "#e2483d"
              },
              "bold": {
                "default": "#ae2e24",
                "hovered": "#5d1f1a"
              }
            },
            "warning": {
              "default": {
                "[default]": "#b38600",
                "hovered": "#946f00"
              },
              "bold": {
                "default": "#7f5f01",
                "hovered": "#533f04"
              }
            },
            "information": {
              "default": {
                "[default]": "#1d7afc",
                "hovered": "#0c66e4"
              },
              "bold": {
                "default": "#0055cc",
                "hovered": "#09326c"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8f7ee7",
                "hovered": "#8270db"
              },
              "bold": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              }
            },
            "categorical": {
              "1": {
                "default": "#2898bd",
                "hovered": "#227d9b"
              },
              "2": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              },
              "3": {
                "default": "#e56910",
                "hovered": "#c25100"
              },
              "4": {
                "default": "#943d73",
                "hovered": "#50253f"
              },
              "5": {
                "default": "#09326c",
                "hovered": "#1c2b41"
              },
              "6": {
                "default": "#8f7ee7",
                "hovered": "#8270db"
              },
              "7": {
                "default": "#50253f",
                "hovered": "#3d2232"
              },
              "8": {
                "default": "#a54800",
                "hovered": "#702e00"
              }
            },
            "blue": {
              "bold": {
                "default": "#388bff",
                "hovered": "#388bff"
              },
              "bolder": {
                "default": "#1d7afc",
                "hovered": "#0c66e4"
              },
              "boldest": {
                "default": "#0055cc",
                "hovered": "#09326c"
              }
            },
            "red": {
              "bold": {
                "default": "#f15b50",
                "hovered": "#e2483d"
              },
              "bolder": {
                "default": "#e2483d",
                "hovered": "#c9372c"
              },
              "boldest": {
                "default": "#ae2e24",
                "hovered": "#5d1f1a"
              }
            },
            "orange": {
              "bold": {
                "default": "#e56910",
                "hovered": "#c25100"
              },
              "bolder": {
                "default": "#c25100",
                "hovered": "#a54800"
              },
              "boldest": {
                "default": "#a54800",
                "hovered": "#702e00"
              }
            },
            "yellow": {
              "bold": {
                "default": "#b38600",
                "hovered": "#946f00"
              },
              "bolder": {
                "default": "#946f00",
                "hovered": "#7f5f01"
              },
              "boldest": {
                "default": "#7f5f01",
                "hovered": "#533f04"
              }
            },
            "green": {
              "bold": {
                "default": "#22a06b",
                "hovered": "#1f845a"
              },
              "bolder": {
                "default": "#1f845a",
                "hovered": "#216e4e"
              },
              "boldest": {
                "default": "#216e4e",
                "hovered": "#164b35"
              }
            },
            "teal": {
              "bold": {
                "default": "#2898bd",
                "hovered": "#227d9b"
              },
              "bolder": {
                "default": "#227d9b",
                "hovered": "#206a83"
              },
              "boldest": {
                "default": "#206a83",
                "hovered": "#164555"
              }
            },
            "purple": {
              "bold": {
                "default": "#8f7ee7",
                "hovered": "#8270db"
              },
              "bolder": {
                "default": "#8270db",
                "hovered": "#6e5dc6"
              },
              "boldest": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              }
            },
            "magenta": {
              "bold": {
                "default": "#da62ac",
                "hovered": "#cd519d"
              },
              "bolder": {
                "default": "#cd519d",
                "hovered": "#ae4787"
              },
              "boldest": {
                "default": "#943d73",
                "hovered": "#50253f"
              }
            },
            "gray": {
              "bold": {
                "default": "#8590a2",
                "hovered": "#758195"
              },
              "bolder": {
                "default": "#758195",
                "hovered": "#626f86"
              },
              "boldest": {
                "default": "#44546f",
                "hovered": "#2c3e5d"
              }
            },
            "lime": {
              "bold": {
                "default": "#6a9a23",
                "hovered": "#5b7f24"
              },
              "bolder": {
                "default": "#5b7f24",
                "hovered": "#4c6b1f"
              },
              "boldest": {
                "default": "#4c6b1f",
                "hovered": "#37471f"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #091e4240, 0px 0px 1px 0px #091e424f",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 8px 12px 0px #091e4226, 0px 0px 1px 0px #091e424f"
            }
          }
        }
      },
      "dark": {
        "colors": {
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#1d2125",
                "hovered": "#1d2125",
                "pressed": "#22272b"
              },
              "sunken": "#161a1d",
              "raised": {
                "default": "#22272b",
                "hovered": "#282e33",
                "pressed": "#2c333a"
              },
              "overlay": {
                "default": "#22272b",
                "hovered": "#2c333a",
                "pressed": "#2c333a"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#0304048f",
                "perimeter": "#091e421f"
              }
            }
          },
          "border": {
            "default": "#a6c5e229",
            "selected": "#579dff",
            "focused": "#cce0ff",
            "subtle": "#bfdbf847",
            "input": "#a6c5e229",
            "inverse": "#161a1d",
            "disabled": "#a1bdd914",
            "brand": "#579dff",
            "danger": "#f15b50",
            "warning": "#f38a3f",
            "success": "#2abb7f",
            "discovery": "#8f7ee7",
            "information": "#388bff",
            "accent": {
              "blue": "#388bff",
              "red": "#f15b50",
              "orange": "#fea362",
              "yellow": "#cf9f02",
              "green": "#2abb7f",
              "purple": "#8f7ee7",
              "teal": "#42b2d7",
              "magenta": "#da62ac",
              "gray": "#738496"
            },
            "table": {
              "default": "#a6c5e229"
            }
          },
          "background": {
            "accent": {
              "blue": {
                "subtlest": "#1c2b41",
                "subtler": "#09326c",
                "subtle": "#0055cc",
                "bolder": "#579dff"
              },
              "red": {
                "subtlest": "#42221f",
                "subtler": "#5d1f1a",
                "subtle": "#ae2e24",
                "bolder": "#f87168"
              },
              "orange": {
                "subtlest": "#38291e",
                "subtler": "#702e00",
                "subtle": "#a54800",
                "bolder": "#fea362"
              },
              "yellow": {
                "subtlest": "#332e1b",
                "subtler": "#533f04",
                "subtle": "#7f5f01",
                "bolder": "#e2b203"
              },
              "green": {
                "subtlest": "#1c3329",
                "subtler": "#164b35",
                "subtle": "#216e4e",
                "bolder": "#4bce97"
              },
              "purple": {
                "subtlest": "#2b273f",
                "subtler": "#352c63",
                "subtle": "#5e4db2",
                "bolder": "#9f8fef"
              },
              "teal": {
                "subtlest": "#1e3137",
                "subtler": "#164555",
                "subtle": "#206a83",
                "bolder": "#6cc3e0"
              },
              "magenta": {
                "subtlest": "#3d2232",
                "subtler": "#50253f",
                "subtle": "#943d73",
                "bolder": "#e774bb"
              },
              "gray": {
                "subtlest": "#2c333a",
                "subtler": "#454f59",
                "subtle": "#596773",
                "bolder": "#8c9bab"
              },
              "lime": {
                "subtlest": "#28311b",
                "subtler": "#37471f",
                "subtle": "#4c6b1f",
                "bolder": "#94c748"
              }
            },
            "input": {
              "default": "#1d2125",
              "hovered": "#22272b",
              "pressed": "#1d2125"
            },
            "inverse": {
              "subtle": {
                "default": "#ffffff29",
                "hovered": "#ffffff3d",
                "pressed": "#ffffff52"
              }
            },
            "neutral": {
              "default": {
                "[default]": "#a1bdd914",
                "hovered": "#a6c5e229",
                "pressed": "#bfdbf847"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#a1bdd914",
                "pressed": "#a6c5e229"
              },
              "bold": {
                "default": "#9fadbc",
                "hovered": "#b6c2cf",
                "pressed": "#c7d1db"
              }
            },
            "brand": {
              "subtlest": {
                "default": "#1c2b41",
                "hovered": "#09326c",
                "pressed": "#0055cc"
              },
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              },
              "boldest": {
                "default": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              }
            },
            "selected": {
              "default": {
                "[default]": "#1c2b41",
                "hovered": "#09326c",
                "pressed": "#09326c"
              },
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              }
            },
            "disabled": "#a1bdd914",
            "information": {
              "default": {
                "[default]": "#1c2b41",
                "hovered": "#09326c",
                "pressed": "#0055cc"
              },
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              }
            },
            "danger": {
              "default": {
                "[default]": "#42221f",
                "hovered": "#5d1f1a",
                "pressed": "#ae2e24"
              },
              "bold": {
                "default": "#f87168",
                "hovered": "#fd9891",
                "pressed": "#ffd5d2"
              }
            },
            "success": {
              "default": {
                "[default]": "#1c3329",
                "hovered": "#164b35",
                "pressed": "#216e4e"
              },
              "bold": {
                "default": "#4bce97",
                "hovered": "#7ee2b8",
                "pressed": "#baf3db"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#2b273f",
                "hovered": "#352c63",
                "pressed": "#5e4db2"
              },
              "bold": {
                "default": "#9f8fef",
                "hovered": "#b8acf6",
                "pressed": "#dfd8fd"
              }
            },
            "warning": {
              "default": {
                "[default]": "#332e1b",
                "hovered": "#533f04",
                "pressed": "#7f5f01"
              },
              "bold": {
                "default": "#f5cd47",
                "hovered": "#e2b203",
                "pressed": "#cf9f02"
              }
            }
          },
          "blanket": {
            "default": "#10121499",
            "selected": "#1d7afc14",
            "danger": "#e3493514"
          },
          "text": {
            "default": "#c7d1db",
            "subtle": "#9fadbc",
            "subtlest": "#8c9bab",
            "disabled": "#bfdbf847",
            "selected": "#579dff",
            "inverse": "#161a1d",
            "success": "#7ee2b8",
            "danger": "#fd9891",
            "information": "#85b8ff",
            "warning": {
              "default": "#f5cd47",
              "inverse": "#161a1d"
            },
            "accent": {
              "blue": {
                "default": "#85b8ff",
                "bolder": "#cce0ff"
              },
              "red": {
                "default": "#fd9891",
                "bolder": "#ffd5d2"
              },
              "orange": {
                "default": "#fec195",
                "bolder": "#fedec8"
              },
              "yellow": {
                "default": "#f8e6a0",
                "bolder": "#f8e6a0"
              },
              "green": {
                "default": "#7ee2b8",
                "bolder": "#baf3db"
              },
              "purple": {
                "default": "#b8acf6",
                "bolder": "#dfd8fd"
              },
              "teal": {
                "default": "#9dd9ee",
                "bolder": "#c6edfb"
              },
              "magenta": {
                "default": "#f797d2",
                "bolder": "#fdd0ec"
              },
              "gray": {
                "default": "#9fadbc",
                "bolder": "#c7d1db"
              },
              "lime": {
                "default": "#b3df72",
                "bolder": "#d3f1a7"
              }
            },
            "discovery": "#b8acf6",
            "brand": "#579dff"
          },
          "link": {
            "default": "#579dff",
            "hovered": "#579dff",
            "pressed": "#85b8ff",
            "visited": "#b8acf6"
          },
          "icon": {
            "accent": {
              "blue": "#388bff",
              "red": "#e2483d",
              "orange": "#f38a3f",
              "yellow": "#f5cd47",
              "green": "#2abb7f",
              "purple": "#8f7ee7",
              "teal": "#42b2d7",
              "magenta": "#da62ac",
              "gray": "#738496",
              "lime": "#82b536"
            },
            "default": "#9fadbc",
            "subtle": "#8c9bab",
            "inverse": "#161a1d",
            "disabled": "#bfdbf847",
            "brand": "#579dff",
            "selected": "#579dff",
            "danger": "#f15b50",
            "success": "#2abb7f",
            "discovery": "#8f7ee7",
            "information": "#388bff",
            "warning": {
              "default": "#f5cd47",
              "inverse": "#161a1d"
            }
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052"
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "chart": {
            "brand": {
              "default": "#388bff",
              "hovered": "#579dff"
            },
            "neutral": {
              "default": "#738496",
              "hovered": "#8c9bab"
            },
            "success": {
              "default": {
                "[default]": "#2abb7f",
                "hovered": "#4bce97"
              },
              "bold": {
                "default": "#7ee2b8",
                "hovered": "#baf3db"
              }
            },
            "danger": {
              "default": {
                "[default]": "#e2483d",
                "hovered": "#f15b50"
              },
              "bold": {
                "default": "#fd9891",
                "hovered": "#ffd5d2"
              }
            },
            "warning": {
              "default": {
                "[default]": "#cf9f02",
                "hovered": "#e2b203"
              },
              "bold": {
                "default": "#f5cd47",
                "hovered": "#f8e6a0"
              }
            },
            "information": {
              "default": {
                "[default]": "#1d7afc",
                "hovered": "#388bff"
              },
              "bold": {
                "default": "#85b8ff",
                "hovered": "#cce0ff"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8270db",
                "hovered": "#8f7ee7"
              },
              "bold": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              }
            },
            "categorical": {
              "1": {
                "default": "#2898bd",
                "hovered": "#42b2d7"
              },
              "2": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              },
              "3": {
                "default": "#e56910",
                "hovered": "#f38a3f"
              },
              "4": {
                "default": "#f797d2",
                "hovered": "#fdd0ec"
              },
              "5": {
                "default": "#cce0ff",
                "hovered": "#e9f2ff"
              },
              "6": {
                "default": "#8270db",
                "hovered": "#8f7ee7"
              },
              "7": {
                "default": "#fdd0ec",
                "hovered": "#ffecf8"
              },
              "8": {
                "default": "#fec195",
                "hovered": "#fedec8"
              }
            },
            "blue": {
              "bold": {
                "default": "#1d7afc",
                "hovered": "#388bff"
              },
              "bolder": {
                "default": "#388bff",
                "hovered": "#579dff"
              },
              "boldest": {
                "default": "#85b8ff",
                "hovered": "#cce0ff"
              }
            },
            "red": {
              "bold": {
                "default": "#e2483d",
                "hovered": "#f15b50"
              },
              "bolder": {
                "default": "#f15b50",
                "hovered": "#f87168"
              },
              "boldest": {
                "default": "#fd9891",
                "hovered": "#ffd5d2"
              }
            },
            "orange": {
              "bold": {
                "default": "#f38a3f",
                "hovered": "#fea362"
              },
              "bolder": {
                "default": "#fea362",
                "hovered": "#fec195"
              },
              "boldest": {
                "default": "#fec195",
                "hovered": "#fedec8"
              }
            },
            "yellow": {
              "bold": {
                "default": "#cf9f02",
                "hovered": "#e2b203"
              },
              "bolder": {
                "default": "#e2b203",
                "hovered": "#f5cd47"
              },
              "boldest": {
                "default": "#f5cd47",
                "hovered": "#f8e6a0"
              }
            },
            "green": {
              "bold": {
                "default": "#2abb7f",
                "hovered": "#4bce97"
              },
              "bolder": {
                "default": "#4bce97",
                "hovered": "#7ee2b8"
              },
              "boldest": {
                "default": "#7ee2b8",
                "hovered": "#baf3db"
              }
            },
            "teal": {
              "bold": {
                "default": "#42b2d7",
                "hovered": "#6cc3e0"
              },
              "bolder": {
                "default": "#6cc3e0",
                "hovered": "#9dd9ee"
              },
              "boldest": {
                "default": "#9dd9ee",
                "hovered": "#c6edfb"
              }
            },
            "purple": {
              "bold": {
                "default": "#8270db",
                "hovered": "#8f7ee7"
              },
              "bolder": {
                "default": "#8f7ee7",
                "hovered": "#9f8fef"
              },
              "boldest": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              }
            },
            "magenta": {
              "bold": {
                "default": "#cd519d",
                "hovered": "#da62ac"
              },
              "bolder": {
                "default": "#da62ac",
                "hovered": "#e774bb"
              },
              "boldest": {
                "default": "#f797d2",
                "hovered": "#fdd0ec"
              }
            },
            "gray": {
              "bold": {
                "default": "#596773",
                "hovered": "#738496"
              },
              "bolder": {
                "default": "#738496",
                "hovered": "#8c9bab"
              },
              "boldest": {
                "default": "#8c9bab",
                "hovered": "#9fadbc"
              }
            },
            "lime": {
              "bold": {
                "default": "#82b536",
                "hovered": "#94c748"
              },
              "bolder": {
                "default": "#94c748",
                "hovered": "#b3df72"
              },
              "boldest": {
                "default": "#b3df72",
                "hovered": "#d3f1a7"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #03040480, 0px 0px 1px 0px #03040480",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 0px 0px 1px #bcd6f00a, 0px 8px 12px 0px #0304045c, 0px 0px 1px 0px #03040480"
            }
          }
        }
      }
    },
    "radii": ["0px", "3px", "4px", "6px", "8px", "9999999px"],
    "size": {
      "0": "0px",
      "4": "4px",
      "8": "8px",
      "12": "12px",
      "16": "16px",
      "20": "20px",
      "24": "24px",
      "28": "28px",
      "32": "32px",
      "36": "36px",
      "40": "40px",
      "44": "44px",
      "48": "48px",
      "64": "64px",
      "80": "80px",
      "96": "96px",
      "112": "112px",
      "128": "128px",
      "144": "144px"
    },
    "space": ["0px", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "fontSize": ["10px", "11px", "12px", "14px", "16px", "20px", "24px", "28px", "29px", "32px", "35px", "36px", "48px", "56px"],
    "lineHeight": {
      "0": "16px",
      "1": "20px",
      "2": "24px",
      "3": "28px",
      "4": "32px",
      "5": "36px",
      "6": "40px",
      "default": 1.429,
      "condensed": 1.143,
      "condensedUltra": 1,
      "relaxed": 1.714
    },
    "fontWeight": {
      "thin": 100,
      "extraLight": 200,
      "light": 300,
      "normal": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "extraBold": 700,
      "black": 700
    },
    "fontStack": {
      "sansSerif": "ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "title": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "normal": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "mono": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace"
    },
    "fontFamily": {
      "sansSerif": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "heading": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "normal": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "mono": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace"
    },
    "font": {
      "heading": {
        "xxsmall": "normal 700 12px/16px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "xsmall": "normal 700 14px/16px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "small": "normal 700 16px/24px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "medium": "normal 700 20px/24px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "large": "normal 700 24px/24px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "xlarge": "normal 700 28px/32px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "xxlarge": "normal 700 29px/40px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
      },
      "body": {
        "[default]": "normal 400 14px/20px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "small": "normal 400 12px/20px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "medium": "400 14px/20px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "large": "normal 400 14px/24px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "xlarge": "normal 500 16px/24px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
      },
      "ui": {
        "[default]": "500 14px/1 \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "small": "500 11px/1 \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
      },
      "caption": {
        "[default]": "normal 400 14px/20px \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
      },
      "code": {
        "[default]": "400 0.875em/1 \"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
        "xsmall": "400 14px/16px \"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
        "small": "400 14px/20px \"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
        "medium": "400 16px/20px \"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace"
      },
      "display": {
        "[default]": "300 96px/1.1 \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
        "medium": "300 80px/1.1 \"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
      }
    },
    "letterSpacing": {
      "0": "0px",
      "1": "-0.003em",
      "2": "-0.006em",
      "3": "-0.008em",
      "4": "-0.01em"
    },
    "fontFamilies": {
      "sansSerif": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "title": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "normal": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "mono": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace"
    },
    "fontSizes": ["10px", "11px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "29px", "35px", "36px", "47px", "62px"],
    "fontWeights": {
      "extraLight": 200,
      "light": 300,
      "normal": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "extraBold": 700,
      "black": 700
    },
    "lineHeights": {
      "0": "16px",
      "1": "20px",
      "2": "24px",
      "3": "28px",
      "4": "32px",
      "5": "36px",
      "6": "40px",
      "default": 1.429,
      "condensed": 1.143,
      "condensedUltra": 1,
      "relaxed": 1.714
    },
    "fonts": {
      "sansSerif": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "heading": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "normal": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "mono": "\"SF Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace"
    }
  }
};

export { themePreval as default };
